import { useNavigationHelper } from 'FrontRoyalAngular';
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SidebarBoxKey } from 'AdmissionsGuidance';
import { BasicDesktopBox } from '../../BasicDesktopBox';
import { type ButtonConfig } from '../../StudentDashboardSidebar.types';

function UploadDocumentsBoxComponent() {
    const { t } = useTranslation('back_royal', { keyPrefix: 'uploadDocumentsBox' });
    const { loadRoute } = useNavigationHelper();

    const buttons = useMemo<ButtonConfig[]>(
        () => [
            {
                id: 'button_upload_documents',
                text: t('buttonUploadDocuments'),
                onPress: () => {
                    loadRoute('/settings/documents');
                },
            },
        ],
        [t, loadRoute],
    );

    return <UploadDocumentsBoxPresentation buttons={buttons} />;
}

function UploadDocumentsBoxPresentation({ buttons }: { buttons: ButtonConfig[] }) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'uploadDocumentsBox' });
    return (
        <BasicDesktopBox boxKey={SidebarBoxKey.upload_documents} headerText={t('header')} buttons={buttons}>
            {t('content')}
        </BasicDesktopBox>
    );
}

export const UploadDocumentsBox = memo(UploadDocumentsBoxComponent) as unknown as typeof UploadDocumentsBoxComponent;
